import React from "react";
import { Modal } from "react-bootstrap";

/**
 * @param {Record<string, unknown> | null | undefined} t
 */
function pickTabletName(t) {
  if (!t || typeof t !== "object") return "";
  const r = /** @type {Record<string, unknown>} */ (t);
  const n = r.name != null ? String(r.name).trim() : "";
  if (n) return n;
  const tn = r.tablet_name != null ? String(r.tablet_name).trim() : "";
  return tn;
}

/**
 * @param {Record<string, unknown> | null | undefined} s
 */
function pickSpot(s) {
  if (!s || typeof s !== "object") return null;
  return /** @type {Record<string, unknown>} */ (s);
}

export default function TabletInfoModal({ show, onHide, tablet }) {
  const t = tablet && typeof tablet === "object"
    ? /** @type {Record<string, unknown>} */ (tablet)
    : null;
  const spot = t ? pickSpot(t.spot_id) : null;

  const tabletName = t ? pickTabletName(t) : "";
  const tabletNumeric = t?.tablet_id != null ? String(t.tablet_id) : "";
  const tabletStatus = t?.status != null ? String(t.status) : "";
  const tabletMongoId = t?._id != null ? String(t._id) : "";

  const spotName = spot && spot.name != null ? String(spot.name) : "";
  const spotAddress = spot && spot.address != null ? String(spot.address) : "";
  const spotNumeric = spot && spot.spot_id != null ? String(spot.spot_id) : "";

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="appModalDialog"
      contentClassName="appModalContent"
      backdropClassName="appModalBackdrop"
    >
      <Modal.Header closeButton className="appModalContent__header">
        <Modal.Title as="h3" className="appModalContent__title m-0">
          Касса
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="appModalContent__body pt-2">
        {!t && (
          <p className="text-muted mb-0">Нет данных по этой кассе.</p>
        )}
        {t && (
          <div className="tabletInfo">
            <div className="tabletInfo__section">
              <div className="tabletInfo__sectionHead">Касса</div>
              <div className="tabletInfo__row">
                <span className="tabletInfo__label">Название:</span>
                <span className="tabletInfo__value">{tabletName || "—"}</span>
              </div>
              {tabletNumeric && (
                <div className="tabletInfo__row">
                  <span className="tabletInfo__label">ID кассы:</span>
                  <span className="tabletInfo__value">{tabletNumeric}</span>
                </div>
              )}
              {tabletStatus && (
                <div className="tabletInfo__row">
                  <span className="tabletInfo__label">Статус:</span>
                  <span className="tabletInfo__value">{tabletStatus}</span>
                </div>
              )}
              {tabletMongoId && (
                <div className="tabletInfo__row tabletInfo__row--muted">
                  <span className="tabletInfo__label">_id:</span>
                  <span className="tabletInfo__value">{tabletMongoId}</span>
                </div>
              )}
            </div>
            <div className="tabletInfo__section">
              <div className="tabletInfo__sectionHead">Заведение</div>
              {!spot && (
                <div className="tabletInfo__row">
                  <span className="text-muted">Нет данных о заведении</span>
                </div>
              )}
              {spot && (
                <>
                  <div className="tabletInfo__row">
                    <span className="tabletInfo__label">Название:</span>
                    <span className="tabletInfo__value">
                      {spotName || "—"}
                    </span>
                  </div>
                  {spotAddress && (
                    <div className="tabletInfo__row">
                      <span className="tabletInfo__label">Адрес:</span>
                      <span className="tabletInfo__value">{spotAddress}</span>
                    </div>
                  )}
                  {spotNumeric && (
                    <div className="tabletInfo__row">
                      <span className="tabletInfo__label">ID заведения:</span>
                      <span className="tabletInfo__value">{spotNumeric}</span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
